import { observer } from 'mobx-react-lite'
import type { ExtensionViewModel } from '@/features/jobs/details/tax-type/ExtensionViewModel'
import { ExtensionFiledSection } from './index'

const testId = 'extension-filed-section'

interface ExtensionFiledSectionContainerProps {
  vm: ExtensionViewModel
}

/**
 * Container for the {@link ExtensionFiledSection}.
 */
export const ExtensionFiledSectionContainer = observer(
  function ExtensionFiledSectionContainer({
    vm,
  }: ExtensionFiledSectionContainerProps) {
    if (!vm.showFiledNotice || !vm.filedAt) {
      return null
    }

    return <ExtensionFiledSection filedAt={vm.filedAt} testId={testId} />
  },
)
